/**
 * @jsxRuntime classic
 * @jsx jsx
 */
import Avatar from '@atlaskit/avatar/avatar';
import { cssMap, jsx } from '@atlaskit/css';

const styles = cssMap({
	slot: {
		display: 'flex',
		alignItems: 'center',
		justifyContent: 'center',
		flexShrink: 0,
		width: '24px',
		height: '24px',
	},
});

/**
 * Placeholder shown in place of the agent's avatar while the reviewing agent is
 * still loading. An ADS hexagon avatar without a `src` renders the generic agent
 * glyph on a neutral tile, matching the shape of the real agent avatar.
 *
 * Decorative: the adjacent "Preparing agent" status text carries the meaning.
 */
export function PreparingAgentAvatar(): JSX.Element {
	return (
		<span css={styles.slot}>
			<Avatar
				appearance="hexagon"
				size="small"
				borderColor="transparent"
				testId="ai-suggestions-preparing-agent-avatar"
			/>
		</span>
	);
}
